module.exports = __webpack_public_path__ + "img/update-course-h5.c5f06a1e.png";